import SectionHero from "./sections/section-hero";
import SectionExtra from "./sections/section-extra";
import SectionManual from "./sections/section-manual";
import SectionSteps from "./sections/section-steps";
import SectionMission from "./sections/section-mission";
import SectionDoubts from "./sections/section-doubts";
import SectionBic from "./sections/section-bic";
import { useEffect } from 'react';

function App() {

  useEffect(() => {
    window.location.href = 'http://estacio.br';
  }, [])

  return (
    <>
      <SectionHero />
      <SectionBic />
      <SectionMission />
      <SectionSteps />
      <SectionManual />
      <SectionExtra />
      <SectionDoubts />
    </>
  );
}

export default App;
